import React from 'react'
import { Col, Row, Spin, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import mymatpic from '$assets/img/mymatpic.png'
import { useQuery } from '@tanstack/react-query'
import {
  fetchAllMaterials,
  fetchOperatorAdditiveMaterialsKpiCount,
} from '$api/evoAPIs'

const { Title } = Typography

const TopKpiCard = () => {
  const { t } = useTranslation()

  const {
    data: operatorAdditiveMaterialsKpiCount,
    isLoading: isLoadingOperatorAdditiveKpis,
  } = useQuery({
    queryKey: ['operatorAdditiveMaterialsKpiCount'],
    queryFn: fetchOperatorAdditiveMaterialsKpiCount,
  })

  const { data: dwhMaterialsPage, isLoading: isLoadingDwh } = useQuery({
    queryKey: ['dwhMaterialsListForKpi'],
    queryFn: () =>
      fetchAllMaterials({
        queryKey: ['dwhMaterialsListForKpi', { page: 1, size: 100 }],
      }),
  })

  return (
    <>
      <Row className="myevocard">
        <Col
          xs={24}
          sm={8}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={mymatpic} width="135px" alt="My Materials Illustration" />
        </Col>
        <Col xs={24} sm={16}>
          <Row
            gutter={[16, 16]}
            style={{
              height: '100%',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Col style={{ width: '33%' }}>
              <Typography.Text>
                {t(
                  'operator_additive_materials.kpi_unmapped_operator_additive_materials',
                )}
              </Typography.Text>
              <Title>
                {isLoadingOperatorAdditiveKpis ? (
                  <Spin size="small" />
                ) : (
                  operatorAdditiveMaterialsKpiCount?.unmapped_materials || 0
                )}
              </Title>
            </Col>
            <Col style={{ width: '33%' }}>
              <Typography.Text>
                {t(
                  'operator_additive_materials.kpi_operator_additive_materials',
                )}
              </Typography.Text>
              <Title>
                {isLoadingOperatorAdditiveKpis ? (
                  <Spin size="small" />
                ) : (
                  operatorAdditiveMaterialsKpiCount?.total_operator_additive_materials ||
                  0
                )}
              </Title>
            </Col>
            <Col xs={24} md={8}>
              <Typography.Text>{t('kpi_dwh_materials')}</Typography.Text>
              <Title>
                {isLoadingDwh ? (
                  <Spin size="small" />
                ) : (
                  dwhMaterialsPage?.total || 0
                )}
              </Title>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default TopKpiCard
